export default{
delivery_management: "إتوزيع السائقين",
delivery_subtitle: "إدارة معلومات موظفي التوصيل",
add_update_delivery: "إضافة / تحديث عامل توصيل",

driver_name: "اسم السائق",
enter_driver_name: "أدخل اسم السائق",

mobile_number: "رقم الجوال",
enter_mobile: "أدخل رقم الجوال",

vehicle_type: "نوع المركبة",
vehicle_type_placeholder: "دراجة / فان",

vehicle_number: "رقم المركبة",
enter_vehicle_number: "أدخل رقم المركبة",

submit_delivery: "إضافة عامل توصيل",
update_delivery: "تحديث عامل توصيل",
delete_delivery: "حذف عامل توصيل",

select_delivery: "اختر عامل توصيل محفوظ",
select_delivery_placeholder: "-- اختر عامل توصيل --",

delivery_required: "⚠️ الاسم ورقم الجوال مطلوبان",
delivery_saved: "✅ تم حفظ عامل التوصيل",
delivery_updated: "✅ تم تحديث عامل التوصيل",
delivery_deleted: "❌ تم حذف عامل التوصيل",

delete_confirm: "هل أنت متأكد من حذف عامل التوصيل؟",
server_error: "❌ خطأ في الخادم",
failed: "فشل",
}